<template>
  <GlassCard
    class="col-lg-2 mb-5 py-3"
    style="max-height: 500px; overflow-x: hidden; overflow-y: scroll"
  >
    <!-- Description -->
    <div class="col-sm-12 col-md-12 form-group pt-3 mt-2 mb-2">
      <div class="html-wrapper" v-html="terms" />
    </div>

    <div class="p-2 m-2 form" />
  </GlassCard>
</template>

<script>
/* State */
import { mapState } from 'vuex'

/* Services */
import { loginFB } from '../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'Termos',
  data: () => ({
    terms: '',
  }),
  computed: {
    ...mapState(['domain', 'subdomain']),
  },
  watch: {
    domain(newValue) {
      if (newValue) this.getTerms()
    },
    subdomain(newValue) {
      if (newValue) this.getTerms()
    },
  },

  methods: {
    getTerms() {
      if (!this.domain || !this.subdomain) return

      lFB
        .getFileContentLoc(this.domain, this.subdomain)
        .then(res => {
          if (res) {
            this.terms = res
          }
        })
        .catch(err => alert(err))
    },
  },
  mounted() {
    this.getTerms()
  },
}
</script>

<style>
.html-wrapper > p {
  font-size: 0.8rem !important;
}

.html-wrapper > h1,
h2,
h3,
h4 {
  font-size: 1.2rem !important;
}

.html-wrapper > h3,
h4 {
  line-height: 1.8rem !important;
}
</style>
